
import { Link } from "react-router-dom";
import PaymentSummaryCard from "../../common/PaymentSummaryCard";

export default function Payment({ payment }) {
	return (
		<Link
			to={`/payment_detail/${payment.id}/`}
			className="group block no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cta/40 focus-visible:ring-offset-2 rounded-[14px]"
		>
			<PaymentSummaryCard
				payment={payment}
				showChevron
				className="transition duration-200 group-hover:border-darkBlue/20 group-hover:shadow-[0_8px_24px_rgba(39,106,166,0.12)]"
			/>
		</Link>
	);
}
